import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { track, routePattern } from '../utils/analytics';

// Fires `Retailer Page Viewed` on every route change with the route PATTERN (never an id).
// Rendered once inside <Router>, so useLocation is available.
const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    track('Retailer Page Viewed', { path: routePattern(location.pathname) });
  }, [location.pathname]);
  return null;
};

export default RouteTracker;
